module.exports = __webpack_public_path__ + "img/head-act.ed42cc95.png";